import React from 'react';

export default function ListItem(props) {
  return <li {...props} />;
}
